import { css } from '@emotion/react';
import * as React from 'react';
import { PlusIcon } from '../../icons';
import { useActions, useSelector } from '../../state/';
import { selectors } from '../../state/editor';
import { BoardMemberForm } from '../BoardMemberForm';
import { ChairForm } from '../ChairForm';
import { FormRow } from '../FormRow';
import { PersonRoleItem } from '../PersonRoleItem';
import { Button } from '../buttons';

type BoardMemberViewKind = 'list' | 'add' | 'edit';

export const BoardMemberList: React.FC = () => {
  const people = useSelector(selectors.peopleWithRolesAndOwnership);
  const { editorActions } = useActions();
  const [view, setView] = React.useState<BoardMemberViewKind>('list');
  const [selectedId, setSelectedId] = React.useState<string>();

  const boardMembers = people.filter(person => {
    return (
      person.roles.includes('boardMember') || person.roles.includes('deputy')
    );
  });

  return (
    <>
      {boardMembers.map(person => {
        if (person.id === selectedId) {
          return (
            <BoardMemberForm
              key={person.id}
              personId={selectedId}
              onDone={() => {
                setSelectedId(undefined);
                setView('list');
              }}
              editType="edit"
            />
          );
        } else {
          return (
            <PersonRoleItem
              key={person.id}
              name={person.name}
              role={person.roles[0]}
              onEdit={() => {
                setView('edit');
                setSelectedId(person.id);
              }}
              onDelete={() => editorActions.removeFromAllRoles(person.id)}
            />
          );
        }
      })}

      {view === 'add' ? (
        <BoardMemberForm
          personId={selectedId}
          onDone={() => setView('list')}
          editType="new"
        />
      ) : (
        <FormRow>
          <Button
            level="secondary"
            onClick={() => {
              setView('add');
              setSelectedId(undefined);
            }}
            icon={
              <PlusIcon
                css={css`
                  margin-top: -2px;
                `}
              />
            }
          >
            Nytt styremedlem
          </Button>
        </FormRow>
      )}
    </>
  );
};

type ChairViewKind = 'list' | 'new' | 'edit';

export const Chair: React.FC = () => {
  const person = useSelector(selectors.getChair);
  const [view, setView] = React.useState<ChairViewKind>('list');

  if (view === 'new') {
    return <ChairForm onDone={() => setView('list')} editType="new" />;
  }

  if (view === 'edit') {
    return (
      <ChairForm
        personId={person.id}
        onDone={() => setView('list')}
        editType="edit"
      />
    );
  }

  return (
    <PersonRoleItem
      name={person.name}
      // eslint-disable-next-line jsx-a11y/aria-role
      role="chair"
      onEdit={() => setView('edit')}
      actions={[
        {
          label: 'Endre styreleder',
          onClick: () => setView('new'),
        },
      ]}
    />
  );
};
